var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconEraser = function SvgIconEraser(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.776 15.5h3.426q.225 0 .383.159a.52.52 0 0 1 .159.383q0 .224-.16.383a.52.52 0 0 1-.382.158h-4.51zm-8.688 1.083q-.15 0-.266-.054a.8.8 0 0 1-.211-.15L2.654 14.42a1.32 1.32 0 0 1-.408-.931q-.01-.535.408-.953L11.28 3.91q.418-.418.946-.414t.946.422l3.652 3.653q.397.397.412.935.015.54-.404.957l-6.915 6.915a.7.7 0 0 1-.215.15.64.64 0 0 1-.27.055zM9.264 15.5l6.795-6.795q.064-.064.064-.184t-.064-.184l-3.66-3.66a.24.24 0 0 0-.18-.065.23.23 0 0 0-.18.072l-8.611 8.61a.27.27 0 0 0-.064.19q0 .116.064.18L5.264 15.5z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconEraser);
export { ForwardRef as ReactComponent };